<template>
    <div>
        <div v-for="qrInfo in qrInfoCp" :key="qrInfo.id" class="cardContainer">
            <div class="qrCard">
                <div class="qrImgContainer">
                    <img class="qrCodeImg" :src="'data:image/png;base64,' + qrInfo.qrCodeImage.imageBytes" alt="QRCode-Image">
                </div>
                <div class="qrInfoContainer">
                    <p class="qrTitle">{{ qrInfo.code }}</p>
                    <!-- <p class="qrDesc"> {{qrInfo.qrCodeType.name}} </p> -->
                    <p v-if="qrType" class="qrDesc"> {{ qrInfo[qrType].name }} </p>
                    <p v-if="qrType" class="qrDesc"> {{ $_getDateTimeFormat(qrInfo[qrType].creationTime) }} </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        qrInfo: {
            type: Array,
            required: true
        },
        qrType: {
            type: String
        }
    },
    computed: {
        qrInfoCp: {
            set() {

            },
            get() {
                return this.qrInfo;
            }
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/QRCard/QRCard.vue